import Vue from 'vue';
import Router from 'vue-router';
import DefaultContainer from '@/containers/DefaultContainer';
import WebsiteNav from '@/components/WebsiteNav';
import home from '@/components/home';
import TemplateNav from '@/components/TemplateNav';
import TemplateConfig from '@/components/TemplateConfig';
import oversae from '@/components/oversae';
import SystemNav from '@/components/SystemNav';
import DefaultParamConfig from '@/components/DefaultParamConfig';
import SyncConfig from '@/components/SyncConfig';
import websiteDetail from '@/components/websiteDetail';
import websiteDetailNav from '@/components/websiteDetailNav';
import activity from '@/components/websiteConfig/activity';
import addArticle from '@/components/websiteConfig/addArticle';
import editOtherSetting from '@/components/websiteConfig/editOtherSetting';
import imgManager from '@/components/websiteConfig/imgManager';
import addImg from '@/components/websiteConfig/addImg';
import settingTable from '@/components/websiteConfig/settingTable';
import otherSettings from '@/components/websiteConfig/otherSettings';
import editSetting from '@/components/websiteConfig/editSetting';
import videoTable from '@/components/websiteConfig/videoTable';
import addVideo from '@/components/websiteConfig/addVideo';
import bannerSet from '@/components/websiteConfig/bannerSet';
import editBanner from '@/components/websiteConfig/editBanner';
import editBasicSet from '@/components/websiteConfig/editBasicSet';
import columnConfig from '@/components/columnConfig/columnConfig';
import columnNav from '@/components/columnConfig/columnNav';
import addColumn from '@/components/columnConfig/addColumn';
import AddTemplate from '@/components/addTemplate';
import SyncAdd from '@/components/SyncAdd';

Vue.use(Router);

export default new Router({

  routes: [
    {
      path: '/',
      component: DefaultContainer,
      redirect: '/website/home',
      // redirect: '/survey/hourReport'
    }, {
      path: '/website',
      component: DefaultContainer,
      redirect: '/website/home',
      children: [{
        path: 'home',
        name: 'home',
        components: {
          default: home,
          navigation: WebsiteNav,
        },
      },
      {
        path: 'oversae',
        name: 'oversae',
        components: {
          default: oversae,
          navigation: WebsiteNav,
        },
      },
      {
        path: 'websiteDetail',
        name: 'websiteDetail',
        components: {
          default: websiteDetail,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'addVideo',
        name: 'addVideo',
        components: {
          default: addVideo,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'addArticle',
        components: {
          default: addArticle,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'addImg',
        components: {
          default: addImg,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'editSetting',
        components: {
          default: editSetting,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'editOtherSetting',
        components: {
          default: editOtherSetting,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'videos',
        components: {
          default: videoTable,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'addVideo',
        components: {
          default: addVideo,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'other_banner',
        components: {
          default: bannerSet,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'editBanner',
        components: {
          default: editBanner,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'otherSettings',
        components: {
          default: otherSettings,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'setting',
        components: {
          default: editBasicSet,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'article',
        components: {
          default: activity,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'img',
        components: {
          default: imgManager,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'other_set',
        components: {
          default: settingTable,
          navigation: websiteDetailNav,
        },
      },
      {
        path: 'ColumnDetail',
        name: 'ColumnDetail',
        components: {
          default: columnConfig,
          navigation: columnNav,
        },
      },
      {
        path: 'addColumn',
        name: 'addColumn',
        components: {
          default: addColumn,
          navigation: columnNav,
        },
      },
      ],
    },
    // {
    //   path: '/websiteSet',
    //   component: DefaultContainer,
    //   children: [{
    //     path: '',
    //     components: {
    //       default: websiteSet,
    //       navigation: WebsiteNav,
    //     },
    //   }],
    // },

    {
      path: '/template',
      component: DefaultContainer,
      children: [{
        path: '',
        components: {
          default: TemplateConfig,
          navigation: TemplateNav,
        },
      },
      {
        path: 'add',
        components: {
          default: AddTemplate,
          navigation: TemplateNav,
        },
      }],
    },
    {
      path: '/system',
      component: DefaultContainer,
      children: [{
        path: '',
        components: {
          default: DefaultParamConfig,
          navigation: SystemNav,
        },
      },
      {
        path: 'sync',
        components: {
          default: SyncConfig,
          navigation: SystemNav,
        },
      },
      {
        path: 'sync-add',
        components: {
          default: SyncAdd,
          navigation: SystemNav,
        },
      }],
    },

  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js